import { v4 as uuidv4 } from 'uuid';

export const createProductActions = (set, get) => ({
  addProduct: (designId, stackId, productData) => {
    const instanceId = uuidv4();
    set((state) => {
      const design = state.designs[designId];
      if (!design) return state;

      return {
        designs: {
          ...state.designs,
          [designId]: {
            ...design,
            Stacks: design.Stacks.map((stack) => (stack.StackId === stackId
              ? {
                ...stack,
                Products: [
                  ...stack.Products,
                  {
                    InstanceId: instanceId,
                    ...productData
                  }
                ]
              }
              : stack)
            )
          }
        }
      };
    });
    return instanceId;
  },

  updateProduct: (designId, stackId, instanceId, productData) => {
    set((state) => {
      const design = state.designs[designId];
      if (!design) return state;

      return {
        designs: {
          ...state.designs,
          [designId]: {
            ...design,
            Stacks: design.Stacks.map((stack) => (stack.StackId === stackId
              ? {
                ...stack,
                Products: stack.Products.map((product) => (product.InstanceId === instanceId
                  ? { ...product, ...productData }
                  : product)
                )
              }
              : stack)
            )
          }
        }
      };
    });
  },

  removeProduct: (designId, stackId, instanceId) => {
    set((state) => {
      const design = state.designs[designId];
      if (!design) return state;

      return {
        designs: {
          ...state.designs,
          [designId]: {
            ...design,
            Stacks: design.Stacks.map((stack) => (stack.StackId === stackId
              ? {
                ...stack,
                Products: stack.Products.filter((product) => product.InstanceId !== instanceId
                )
              }
              : stack)
            )
          }
        }
      };
    });
  }
});
